import React, { useMemo } from 'react';
import StatusWithDraft from '../../../../model/StatusWithDraft';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import useLabel from '../../utils/Translations/useLabel';
import SelectBoxFilter from './SelectBoxFilter';
const StatusWithDraftSelector = ({ value, onChange, title, name, hasAllOption = false, menuClassName, dataCy, }) => {
    const { options, allOptions, optionsByValue } = useEnumerableModel(StatusWithDraft);
    const allOptionsWithValue = useMemo(() => ({
        ...allOptions,
        value: 'ALL',
        sequence: 0,
    }), [allOptions]);
    const statusOptions = useMemo(() => hasAllOption
        ? [allOptionsWithValue, { divider: true }, ...options]
        : options, [options, allOptionsWithValue, hasAllOption]);
    const valueWithFallback = useMemo(() => {
        const valueWithFallback = value ? optionsByValue[value] : undefined;
        if (!value || !valueWithFallback) {
            return allOptionsWithValue.value;
        }
        return valueWithFallback.value;
    }, [optionsByValue, value, allOptionsWithValue]);
    const _title = useLabel('Status', title);
    return (<SelectBoxFilter dataCy={dataCy} includeAll={hasAllOption} menuClassName={menuClassName} name={name} options={statusOptions} title={_title} value={valueWithFallback} onChange={onChange}/>);
};
export default StatusWithDraftSelector;
